/*
  SalonID — Samplebox samenstellen (okt 2026).

  Je kiest producten, elk één keer (Nino, 23-10-2026); elke zes worden een
  box, de laatste box krijgt de rest. Het aantal in een box bepaalt zijn
  variant "Sample N" (staffelprijs). Toevoegen stuurt per box precies wat de
  cart transform en het magazijn verwachten: één regel (variant N, aantal 1)
  met "Product 1".."Product N" (namen, in de volgorde van kiezen) en
  "_samplebox" (variant-id's in dezelfde volgorde), alle boxen in één
  /cart/add. De keuze blijft bewaard tijdens het bezoek (sessionStorage),
  zodat een herladen of terug-knop je box niet leegmaakt.

  Niet te kiezen: uitverkocht, al als sample gehad (.is-had, uit de Studio)
  en al in een box in de winkelwagen ([data-sb-in-cart], daarna ververst bij
  elke wijziging van de winkelwagen).

  Ontwerp op de samples (alleen als de sectie [data-sb-design] toont): bij
  "Mijn eigen ontwerp" krijgt elke fles haar ontwerp (elk product komt één
  keer); dan gaan "Ontwerp" + "_ontwerp" = eigen mee op elke box en in
  dezelfde /cart/add de toeslag, één per box. Daarna zet
  sid-sample-design.js het winkelwagenkenmerk.
*/
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || '€{{amount_with_comma_separator}}';
    var parts = value.split('.');
    var thousandsDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var thousandsComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, thousandsDot)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, thousandsComma);
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function init(root) {
    if (root.dataset.sidReady) return;
    root.dataset.sidReady = 'true';

    var tiers = JSON.parse(root.querySelector('[data-sb-tiers]').textContent);
    var strings = JSON.parse(root.querySelector('[data-sb-strings]').textContent);
    var max = parseInt(root.dataset.max, 10) || 6;
    var money = function (cents) { return formatMoney(cents, root.dataset.moneyFormat); };
    var storageKey = root.dataset.storageKey;

    var options = {};
    root.querySelectorAll('[data-sb-option]').forEach(function (el) {
      options[el.dataset.sbOption] = {
        el: el,
        id: el.dataset.sbOption,
        name: el.dataset.name,
        handle: el.dataset.handle,
        label: el.dataset.label,
        img: el.dataset.img || ''
      };
    });

    var els = {
      count: root.querySelector('[data-sb-count]'),
      boxes: root.querySelector('[data-sb-boxes]'),
      label: root.querySelector('[data-sb-label]'),
      price: root.querySelector('[data-sb-price]'),
      compare: root.querySelector('[data-sb-compare]'),
      hint: root.querySelector('[data-sb-hint]'),
      submit: root.querySelector('[data-sb-submit]'),
      submitLabel: root.querySelector('[data-sb-submit-label]'),
      error: root.querySelector('[data-sb-error]'),
      bar: root.querySelector('[data-sb-bar]'),
      barCount: root.querySelector('[data-sb-bar-count]'),
      barPrice: root.querySelector('[data-sb-bar-price]'),
      barSubmit: root.querySelector('[data-sb-bar-submit]'),
      box: root.querySelector('.sid-sb__box'),
      extra: root.querySelector('[data-sb-extra]')
    };

    // De vaste balk hoort bij het scherm: secties van het thema krijgen een
    // transform (reveal-animatie), waardoor position: fixed anders aan de
    // sectie vastzit. Daarom staat hij direct in <body>.
    if (els.bar) {
      var oldBar = document.getElementById(els.bar.id);
      if (oldBar && oldBar !== els.bar) oldBar.remove();
      document.body.appendChild(els.bar);
    }

    // Ontwerp op de samples
    var design = root.querySelector('[data-sb-design]');
    var designKey = storageKey + '-ontwerp';
    var designChoice = 'salonid';
    var designFee = design ? parseInt(design.dataset.price, 10) || 0 : 0;
    if (design) {
      try {
        if (sessionStorage.getItem(designKey) === 'eigen') designChoice = 'eigen';
      } catch (e) { /* geen opslag: SalonID-ontwerp */ }
      design.querySelectorAll('[data-sb-design-input]').forEach(function (input) {
        input.checked = input.value === designChoice;
        input.addEventListener('change', function () {
          if (!input.checked) return;
          designChoice = input.value;
          try { sessionStorage.setItem(designKey, designChoice); } catch (e) { /* negeren */ }
          render();
        });
      });
    }

    // Al in een box in de winkelwagen: bij het laden uit de pagina, daarna uit /cart.js
    var inCart = {};
    try {
      JSON.parse(root.querySelector('[data-sb-in-cart]').textContent).forEach(function (id) { inCart[String(id)] = true; });
    } catch (e) { /* niets bekend */ }

    function blocked(id) {
      var o = options[id];
      return !o || !!inCart[id] || o.el.classList.contains('is-unavailable') || o.el.classList.contains('is-had');
    }

    var picks = [];
    var busy = false;
    try {
      var saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      if (Array.isArray(saved)) {
        picks = saved.filter(function (id, i) { return saved.indexOf(id) === i && !blocked(id); });
      }
    } catch (e) { /* geen opslag: begin leeg */ }

    function save() {
      try { sessionStorage.setItem(storageKey, JSON.stringify(picks)); } catch (e) { /* negeren */ }
    }

    function tierFor(n) {
      return tiers.find(function (t) { return t.count === n; }) || null;
    }

    function each(tier) {
      return Math.round(tier.price / tier.count);
    }

    // elke zes een box, de laatste krijgt de rest
    function boxesOf(list) {
      var out = [];
      for (var i = 0; i < list.length; i += max) out.push(list.slice(i, i + max));
      return out;
    }

    function productsText(n) {
      if (n === 1) return strings.totalOne;
      return (strings.totalByCount && strings.totalByCount[n]) || strings.totalOther.replace('[n]', n);
    }

    function summary(n, boxCount) {
      return productsText(n) + ' · ' + ((strings.boxesByCount && strings.boxesByCount[boxCount]) || boxCount);
    }

    function removeHtml(pick, at) {
      return '<button type="button" class="sid-sb__slot-remove" data-sb-remove="' + at + '" aria-label="' + escapeHtml(strings.remove.replace('[name]', pick.label)) + '">' +
        '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></button>';
    }

    function slotHtml(id, at, showTags) {
      var pick = options[id];
      return '<li class="sid-sb__slot">' +
        '<span class="sid-sb__slot-img">' + (pick.img ? '<img src="' + escapeHtml(pick.img) + '" alt="" width="40" height="50">' : '') + '</span>' +
        (showTags
          ? '<span class="sid-sb__slot-body"><span class="sid-sb__slot-text">' + escapeHtml(pick.label) + '</span>' +
            '<span class="sid-sb__slot-tag is-own">' + escapeHtml(strings.designTagOwn) + '</span></span>'
          : '<span class="sid-sb__slot-text">' + escapeHtml(pick.label) + '</span>') +
        removeHtml(pick, at) +
        '</li>';
    }

    function render() {
      var n = picks.length;
      var boxes = boxesOf(picks);
      var last = boxes.length ? boxes[boxes.length - 1] : [];
      var own = !!design && designChoice === 'eigen';
      var fee = own ? designFee * boxes.length : 0;
      var left = Object.keys(options).filter(function (id) { return !blocked(id) && picks.indexOf(id) === -1; }).length;

      var price = 0;
      var compare = 0;
      var available = n > 0;
      boxes.forEach(function (box) {
        var t = tierFor(box.length);
        if (!t || !t.available) {
          available = false;
          return;
        }
        price += t.price;
        compare += t.compare && t.compare > t.price ? t.compare : t.price;
      });

      Object.keys(options).forEach(function (id) {
        var o = options[id];
        var picked = picks.indexOf(id) > -1;
        var add = o.el.querySelector('[data-sb-add]');
        var pickedButton = o.el.querySelector('[data-sb-less]');
        var note = o.el.querySelector('[data-sb-in-cart-note]');
        o.el.classList.toggle('is-picked', picked);
        o.el.classList.toggle('is-in-cart', !!inCart[id] && !o.el.classList.contains('is-had'));
        if (note) note.hidden = !inCart[id];
        if (!add || !pickedButton) return;
        add.hidden = picked;
        add.disabled = !!inCart[id];
        pickedButton.hidden = !picked;
      });

      root.querySelectorAll('[data-ladder]').forEach(function (li) {
        li.classList.toggle('is-current', parseInt(li.dataset.ladder, 10) === last.length);
      });

      if (boxes.length > 1) els.count.textContent = summary(n, boxes.length);
      else els.count.textContent = last.length >= max ? strings.countFull : strings.count.replace('[n]', n);

      // De boxen: eerdere volle boxen klein (alleen de flesjes), de laatste met namen.
      var multi = boxes.length > 1 || last.length === max;
      var shown = boxes.length ? boxes : [[]];
      var html = '';
      shown.forEach(function (box, b) {
        var start = b * max;
        var tier = tierFor(box.length);
        var head = multi
          ? '<p class="sid-sb__box-head"><span>' + escapeHtml(strings.boxN.replace('[n]', b + 1)) + '</span>' + (tier ? '<span>' + money(tier.price) + '</span>' : '') + '</p>'
          : '';
        if (b < shown.length - 1) {
          html += '<div class="sid-sb__boxgrp is-done">' + head + '<ul class="sid-sb__thumbs" role="list">' +
            box.map(function (id, k) {
              var pick = options[id];
              return '<li class="sid-sb__thumb" title="' + escapeHtml(pick.label) + '">' +
                (pick.img ? '<img src="' + escapeHtml(pick.img) + '" alt="' + escapeHtml(pick.label) + '" width="40" height="50">' : '<span>' + escapeHtml(pick.label) + '</span>') +
                removeHtml(pick, start + k) + '</li>';
            }).join('') + '</ul></div>';
          return;
        }
        html += '<div class="sid-sb__boxgrp">' + head + '<ol class="sid-sb__slots" role="list">';
        for (var i = 0; i < max; i++) {
          html += box[i]
            ? slotHtml(box[i], start + i, own)
            : '<li class="sid-sb__slot is-empty"><span class="sid-sb__slot-n">' + (i + 1) + '</span><span class="sid-sb__slot-text">' + escapeHtml(strings.slotFree) + '</span></li>';
        }
        html += '</ol></div>';
      });
      if (last.length === max && left > 0) {
        html += '<p class="sid-sb__slot-next">' + escapeHtml(strings.slotNext.replace('[n]', boxes.length + 1)) + '</p>';
      }
      els.boxes.innerHTML = html;

      if (n > 0) {
        els.label.textContent = boxes.length > 1 ? summary(n, boxes.length) : productsText(n);
        els.price.textContent = money(price);
        els.price.classList.remove('is-from');
        els.compare.textContent = money(compare);
        els.compare.hidden = !(compare > price);
      } else {
        els.label.textContent = strings.totalEmpty;
        els.price.textContent = strings.from.replace('[price]', money(tierFor(1) ? tierFor(1).price : 0));
        els.price.classList.add('is-from');
        els.compare.hidden = true;
      }

      // De hint gaat over de laatste box: wat de volgende fles kost, of dat er een nieuwe box begint.
      var lastTier = tierFor(last.length);
      var next = tierFor(last.length + 1);
      if (n === 0) {
        els.hint.textContent = strings.hintStart;
      } else if (last.length === max && lastTier) {
        els.hint.textContent = strings.hintFull.replace('[each]', money(each(lastTier))) +
          (left > 0 ? ' ' + strings.hintMore.replace('[n]', boxes.length + 1) : '');
      } else if (next && left > 0) {
        els.hint.textContent = strings.hintNext
          .replace('[n]', next.count)
          .replace('[price]', money(next.price))
          .replace('[each]', money(each(next)));
      } else {
        els.hint.textContent = '';
      }

      if (design) {
        design.querySelector('[data-sb-design-info]').hidden = !own;
        if (els.extra) {
          els.extra.hidden = !(n > 0 && fee > 0);
          els.extra.lastElementChild.textContent = '+ ' + money(fee);
        }
      }

      var canAdd = available && !busy;
      var addText = n > 0 ? strings.add.replace('[price]', money(price + fee)) : strings.addEmpty;
      els.submit.disabled = !canAdd;
      els.barSubmit.disabled = !canAdd;
      if (!busy) els.submitLabel.textContent = addText;

      els.barCount.textContent = boxes.length > 1 ? summary(n, boxes.length) : strings.barCount.replace('[n]', n);
      els.barPrice.textContent = n > 0 ? money(price + fee) : '';
      updateBar();
      save();
    }

    function addPick(id) {
      if (blocked(id) || picks.indexOf(id) > -1) return;
      picks.push(id);
      clearError();
      render();
    }

    function removePick(id) {
      var index = picks.indexOf(id);
      if (index > -1) picks.splice(index, 1);
      render();
    }

    function clearError() {
      els.error.hidden = true;
      els.error.textContent = '';
    }

    function focusAfterRender(selector) {
      var target = root.querySelector(selector);
      if (target && !target.disabled && !target.hidden) target.focus();
    }

    root.addEventListener('click', function (event) {
      var add = event.target.closest('[data-sb-add]');
      var less = event.target.closest('[data-sb-less]');
      var remove = event.target.closest('[data-sb-remove]');
      var option = event.target.closest('[data-sb-option]');

      if (add && option) {
        addPick(option.dataset.sbOption);
        focusAfterRender('[data-sb-option="' + option.dataset.sbOption + '"] [data-sb-less]');
      } else if (less && option) {
        removePick(option.dataset.sbOption);
        focusAfterRender('[data-sb-option="' + option.dataset.sbOption + '"] [data-sb-add]');
      } else if (remove) {
        var at = parseInt(remove.dataset.sbRemove, 10);
        picks.splice(at, 1);
        render();
        var slotButtons = root.querySelectorAll('[data-sb-remove]');
        if (slotButtons.length) slotButtons[Math.min(at, slotButtons.length - 1)].focus();
        else els.count.focus();
      }
    });

    // Een box die uit de winkelwagen gaat, maakt zijn producten weer vrij (en andersom).
    function refreshCart() {
      var routes = window.routes || {};
      return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart || busy) return;
          inCart = {};
          cart.items.forEach(function (item) {
            var ids = item.properties && item.properties._samplebox;
            if (ids) String(ids).split(',').forEach(function (id) { inCart[id.trim()] = true; });
          });
          picks = picks.filter(function (id) { return !blocked(id); });
          render();
        })
        .catch(function () { /* blijft zoals het was */ });
    }
    document.addEventListener('cart:update', refreshCart);

    /*
      Het magazijn leest "Product N" in het Nederlands ("Mousse | Eigen Merk - X-Strong").
      In een vertaalde winkel (/de/, /nb/ …) staan titels op de pagina vertaald; daarom
      halen we de namen dan op via /variants/<id>.js zonder taalmap. Dat geeft de
      oorspronkelijke "name" (producttitel + " - " + variant) en werkt ook met vertaalde
      URL's (/products/<vertaalde-handle>.js zonder taalmap geeft 404). Lukt het niet,
      dan gaat de paginanaam mee.
    */
    function nlNames(ids) {
      var names = {};
      ids.forEach(function (id) { names[id] = options[id].name; });
      // "/" op de Nederlandse site, "/nb/" enz. in een vertaalde versie
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
        (window.routes && window.routes.root_url) || '/';
      if (root === '/' || !window.fetch) return Promise.resolve(names);
      var unique = ids.filter(function (id, i) { return ids.indexOf(id) === i; });
      return Promise.all(unique.map(function (id) {
        return fetch('/variants/' + encodeURIComponent(id) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (variant) {
            if (variant && variant.name) names[id] = variant.name.replace(/ \/ /g, ' - ');
          })
          .catch(function () { /* paginanaam blijft staan */ });
      })).then(function () { return names; });
    }

    function submit() {
      var chosen = picks.slice();
      var boxes = boxesOf(chosen);
      var boxTiers = boxes.map(function (box) { return tierFor(box.length); });
      if (busy || !boxes.length || boxTiers.some(function (t) { return !t || !t.available; })) return;

      busy = true;
      clearError();
      els.submit.disabled = true;
      els.barSubmit.disabled = true;
      els.submitLabel.textContent = strings.adding;

      var ownDesign = !!design && designChoice === 'eigen';
      var routes = window.routes || {};
      nlNames(chosen).then(function (names) {
        var items = boxes.map(function (box, b) {
          var properties = {};
          box.forEach(function (id, i) { properties['Product ' + (i + 1)] = names[id]; });
          if (design) {
            // Vaste Nederlandse waarden (magazijn, Studio); de winkelwagen toont ze vertaald via _ontwerp.
            properties.Ontwerp = ownDesign ? 'Mijn eigen ontwerp' : 'SalonID-ontwerp';
            properties._ontwerp = ownDesign ? 'eigen' : 'salonid';
          }
          properties._samplebox = box.join(',');
          return { id: boxTiers[b].id, quantity: 1, properties: properties };
        });
        // Shopify zet het laatst toegevoegde bovenaan: box 1 bovenaan, de toeslag eronder
        items.reverse();
        if (ownDesign) items.unshift({ id: parseInt(design.dataset.variantId, 10), quantity: boxes.length });
        return fetch((routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        });
      })
        .then(function (response) {
          return response.json().then(function (json) { return { ok: response.ok, json: json }; });
        })
        .then(function (result) {
          if (!result.ok || result.json.status) throw new Error(result.json.description || result.json.message || strings.error);
          // in de winkelwagen: niet nog een keer te kiezen
          chosen.forEach(function (id) { inCart[id] = true; });
          if (!design || !window.SidSampleDesign) return result;
          return window.SidSampleDesign.sync({ render: false }).then(function () { return result; });
        })
        .then(function (result) {
          picks = [];
          busy = false;
          render();
          els.submitLabel.textContent = strings.added;
          setTimeout(function () { if (!busy) render(); }, 2200);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: result.json } }));
        })
        .catch(function (error) {
          busy = false;
          render();
          els.error.textContent = (error && error.message) || strings.error;
          els.error.hidden = false;
        });
    }

    els.submit.addEventListener('click', submit);
    els.barSubmit.addEventListener('click', submit);

    // Vaste balk op mobiel: alleen zolang de box-kaart niet in beeld is.
    var boxVisible = false;
    function updateBar() {
      var show = window.matchMedia('(max-width: 989px)').matches && !boxVisible;
      els.bar.hidden = !show;
      root.classList.toggle('has-bar', show);
      document.body.classList.toggle('sid-sb-bar-open', show);
    }
    if ('IntersectionObserver' in window && els.box) {
      new IntersectionObserver(function (entries) {
        boxVisible = entries[0].isIntersecting;
        updateBar();
      }, { rootMargin: '0px 0px -40px 0px' }).observe(els.box);
    }
    window.addEventListener('resize', updateBar);

    render();
  }

  function boot() {
    document.querySelectorAll('[data-sid-sb]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
